import { FormData } from '@/components'
import { NumberContext } from '@/components/Numbers/Numbers.type'

export const getNumbers = async (context: NumberContext) => {
  const res = await fetch(`/api/numbers?query=${context}`, { cache: 'no-cache' })
  return await res.json()
}

export const getPartner = async (partnerCode: string) => {
  const res = await fetch(`/api/partner?partnerCode=${partnerCode}`, { cache: 'no-cache' })
  return await res.json()
}

export const postLead = async (formData: FormData) => {
  try {
    const res = await fetch(`/api/salesforce`, {
      cache: 'no-cache',
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'Content-Type': 'application/json' }
    })

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`)
    }

    return await res.json()
  } catch (error) {
    console.warn('Error posting lead from envelope:', error)
    throw error // Repassa o erro para o chamador
  }
}

export const postIdEnvelopDocSignToSalesForce = async (leadId: string, email: string) => {
  try {
    const res = await fetch(`/api/salesforce/docusign`, {
      cache: 'no-cache',
      method: 'POST',
      body: JSON.stringify({ leadId, email }),
      headers: { 'Content-Type': 'application/json' }
    })

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`)
    }

    return await res.json()
  } catch (error) {
    console.warn('Error posting lead from envelope:', error)
    throw error // Repassa o erro para o chamador
  }
}
